// extracted by mini-css-extract-plugin
export default {"wrapper":"uSk_IwjgjCHIcYB2Belh"};